import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { fetchAllTypeaheadLicenseManufacturers, clearTypeahed } from '../../../actions';
import MultiTypeahead from './MultiTypeahead';
import renderMultiSuggestion from '../RenderMultiSuggestion';

class LicenseManufacturerTypeahead extends Component {
    static propTypes = {
        fetchAllTypeaheadLicenseManufacturers: PropTypes.func.isRequired,
        clearTypeahed: PropTypes.func.isRequired,
        suggestions: PropTypes.array,
        error: PropTypes.string,
        onChangeSuggestion: PropTypes.func.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
        renderMultiSuggestion: PropTypes.func
    };

    static defaultProps = {
        suggestions: [],
        renderMultiSuggestion
    };

    state = {
        isLoading: false
    };

    onFocus = async () => {
        this.setState({ isLoading: true });

        try {
            await this.props.fetchAllTypeaheadLicenseManufacturers(LicenseManufacturerTypeahead.name);
        } finally {
            this.setState({ isLoading: false });
        }
    };

    render() {
        const options = this.props.suggestions.map(license => ({ label: license.name, value: license.id }));

        return (
            <MultiTypeahead
                options={options}
                isMulti
                isLoading={this.state.isLoading}
                value={this.props.value}
                titleId="licenseManufacturerName"
                animatedPlaceholder
                onChangeSuggestion={this.props.onChangeSuggestion}
                onFocus={this.onFocus}
                formatOptionLabel={this.props.renderMultiSuggestion}
                handleSuggestionsClearRequested={this.props.clearTypeahed}
                error={this.props.error}
                t={this.props.t}
            />
        );
    }
}

const mapStateToProps = ({ typeahead }) => ({
    suggestions:
        typeahead.source === LicenseManufacturerTypeahead.name
            ? typeahead.list
            : LicenseManufacturerTypeahead.defaultProps.suggestions
});

export default connect(mapStateToProps, {
    fetchAllTypeaheadLicenseManufacturers,
    clearTypeahed
})(LicenseManufacturerTypeahead);
